"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHINE_START_DOCUMENT_ERRORS = exports.SHINE_START_REFUSAL_REASONS = exports.SHINE_START_DOCUMENT_STATUS = exports.SHINE_START_DOCUMENT_TYPES = exports.SHINE_START_STATUS = void 0;
exports.SHINE_START_STATUS = {
    APPLICATION_INVALID: 'APPLICATION_INVALID',
    APPLICATION_SUBMITTED: 'APPLICATION_SUBMITTED',
    APPLICATION_VALIDATED: 'APPLICATION_VALIDATED',
    COMPANY_REGISTERED: 'COMPANY_REGISTERED',
    FORM_COMPLETED: 'FORM_COMPLETED',
    OPTED_OUT: 'OPTED_OUT',
    PENDING: 'PENDING',
    REFUSED: 'REFUSED',
    SENT_TO_STATE: 'SENT_TO_STATE',
};
exports.SHINE_START_DOCUMENT_TYPES = {
    ACCRE: 'ACCRE',
    AUTHORIZATION_COMMUNICATE_THIRD_PARTIES: 'AUTHORIZATION_COMMUNICATE_THIRD_PARTIES',
    BIKE_DELIVERY_STATEMENT: 'BIKE_DELIVERY_STATEMENT',
    CELIBACY_STATEMENT: 'CELIBACY_STATEMENT',
    CERTIFICATE_DELIVERY_INFORMATION_SPOUSE: 'CERTIFICATE_DELIVERY_INFORMATION_SPOUSE',
    COMMERCIAL_LEASE: 'COMMERCIAL_LEASE',
    COMPANY_CERTIFICATE_OF_RESIDENCE: 'COMPANY_CERTIFICATE_OF_RESIDENCE',
    COMPENDIUM_OF_ASSENT: 'COMPENDIUM_OF_ASSENT',
    DIPLOMA_OR_PROOF_OF_EXPERIENCE: 'DIPLOMA_OR_PROOF_OF_EXPERIENCE',
    DRIVING_LICENSE_RECTO: 'DRIVING_LICENSE_RECTO',
    DRIVING_LICENSE_VERSO: 'DRIVING_LICENSE_VERSO',
    DRONE_PILOT_CERTIFICATE: 'DRONE_PILOT_CERTIFICATE',
    ECSR_LICENSE_TITLE: 'ECSR_LICENSE_TITLE',
    GENERIC: 'GENERIC',
    ID_RECTO_OWNER: 'ID_RECTO_OWNER',
    ID_VERSO_OWNER: 'ID_VERSO_OWNER',
    JPQA_FORM: 'JPQA_FORM',
    NO_CRIMINAL_CONVICTION_STATEMENT: 'NO_CRIMINAL_CONVICTION_STATEMENT',
    P0: 'P0',
    PACS_OR_MARRIAGE_CONTRACT_FAMILY_BOOK: 'PACS_OR_MARRIAGE_CONTRACT_FAMILY_BOOK',
    POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
    PROOF_OF_IDENTITY_HAND_WRITTEN: 'PROOF_OF_IDENTITY_HAND_WRITTEN',
    PROOF_OF_RADIATION: 'PROOF_OF_RADIATION',
    PROOF_OF_REQUEST_ADDRESS_CHANGE: 'PROOF_OF_REQUEST_ADDRESS_CHANGE',
    PROOF_PROVISION_OWNER: 'PROOF_PROVISION_OWNER',
    PROOF_REGISTRATION_TRANSPORTATION_RENTAL: 'PROOF_REGISTRATION_TRANSPORTATION_RENTAL',
    PROPERTY_TAX_RECTO: 'PROPERTY_TAX_RECTO',
    PROPERTY_TAX_VERSO: 'PROPERTY_TAX_VERSO',
    REQUEST_FOR_NON_ASSISTANCE: 'REQUEST_FOR_NON_ASSISTANCE',
    VITALE_CARD: 'VITALE_CARD',
    VTC_CARD_RECTO: 'VTC_CARD_RECTO',
    VTC_CARD_VERSO: 'VTC_CARD_VERSO',
};
exports.SHINE_START_DOCUMENT_STATUS = {
    MISSING: 'MISSING',
    PENDING: 'PENDING',
    REFUSED: 'REFUSED',
    VALIDATED: 'VALIDATED',
};
exports.SHINE_START_REFUSAL_REASONS = {
    GENERIC: 'GENERIC',
    MARRIED_IN_COMMUNITY_OF_PROPERTY: 'MARRIED_IN_COMMUNITY_OF_PROPERTY',
    MINOR: 'MINOR',
    NO_PAPERLESS: 'NO_PAPERLESS',
    STUDENT_FOREIGNER: 'STUDENT_FOREIGNER',
    UNSUPPORTED_JOB: 'UNSUPPORTED_JOB',
};
exports.SHINE_START_DOCUMENT_ERRORS = {
    ASSEMBLY_SIGNATURE: 'ASSEMBLY_SIGNATURE',
    BIRTH_BOROUGH_MISSING: 'BIRTH_BOROUGH_MISSING',
    BIRTH_PLACE_MISSING: 'BIRTH_PLACE_MISSING',
    BIRTH_ZIP_MISSING: 'BIRTH_ZIP_MISSING',
    BLACK_AND_WHITE: 'BLACK_AND_WHITE',
    BLURRY: 'BLURRY',
    CITY_MENTION: 'CITY_MENTION',
    CONTRACT_COMM_LEASE_INVALID: 'CONTRACT_COMM_LEASE_INVALID',
    CONTRACT_DOM_INVALID: 'CONTRACT_DOM_INVALID',
    CONTRACT_INCOMPLETE: 'CONTRACT_INCOMPLETE',
    CROPPED: 'CROPPED',
    DECLARANT_CHECKED: 'DECLARANT_CHECKED',
    DIPLOMA_BOX: 'DIPLOMA_BOX',
    DIPLOMA_INVALID: 'DIPLOMA_INVALID',
    DRIVING_LICENSE_NOT_SUPPORTED: 'DRIVING_LICENSE_NOT_SUPPORTED',
    DRIVING_LICENSE_RECTO_INVALID: 'DRIVING_LICENSE_RECTO_INVALID',
    DRIVING_LICENSE_VERSO_INVALID: 'DRIVING_LICENSE_VERSO_INVALID',
    EMPTY_DOCUMENT: 'EMPTY_DOCUMENT',
    EXPIRED: 'EXPIRED',
    EXPIRED_ID: 'EXPIRED_ID',
    FALSIFIED: 'FALSIFIED',
    GENERIC: 'GENERIC',
    HANDWRITTEN_MENTION: 'HANDWRITTEN_MENTION',
    HANDWRITTEN_SIGNATURE: 'HANDWRITTEN_SIGNATURE',
    ID_INVALID: 'ID_INVALID',
    ID_RECTO_OWNER_INVALID: 'ID_RECTO_OWNER_INVALID',
    ID_VERSO_OWNER_INVALID: 'ID_VERSO_OWNER_INVALID',
    INCONSISTENT_ACTIVITY: 'INCONSISTENT_ACTIVITY',
    INCONSISTENT_DATE: 'INCONSISTENT_DATE',
    INCONSISTENT_MARITAL_STATUS: 'INCONSISTENT_MARITAL_STATUS',
    INCONSISTENT_RESIDENCE_PERMIT_DATE: 'INCONSISTENT_RESIDENCE_PERMIT_DATE',
    INCORRECT_ADDRESS: 'INCORRECT_ADDRESS',
    INCORRECT_BIRTH_CITY: 'INCORRECT_BIRTH_CITY',
    INCORRECT_FIRST_FORENAME: 'INCORRECT_FIRST_FORENAME',
    INCORRECT_FIRST_NAME: 'INCORRECT_FIRST_NAME',
    INCORRECT_LAST_NAME: 'INCORRECT_LAST_NAME',
    INCORRECT_NAME: 'INCORRECT_NAME',
    INCORRECT_OWNER_FIRST_NAME: 'INCORRECT_OWNER_FIRST_NAME',
    INCORRECT_OWNER_LAST_NAME: 'INCORRECT_OWNER_LAST_NAME',
    INTERLEAVE_BOX: 'INTERLEAVE_BOX',
    INVALID_DATE: 'INVALID_DATE',
    JQPA_INVALID: 'JQPA_INVALID',
    MARRIAGE_INVALID: 'MARRIAGE_INVALID',
    MISSING: 'MISSING',
    MISSING_BIKE_KEYWORD: 'MISSING_BIKE_KEYWORD',
    MISSING_CITY: 'MISSING_CITY',
    MISSING_DATE: 'MISSING_DATE',
    MISSING_ID: 'MISSING_ID',
    MISSING_MARITAL_STATUS: 'MISSING_MARITAL_STATUS',
    MISSING_MENTION: 'MISSING_MENTION',
    MISSING_OWNER_ADDRESS: 'MISSING_OWNER_ADDRESS',
    MISSING_PARENT_FIRST_NAME: 'MISSING_PARENT_FIRST_NAME',
    MISSING_PROPERTY_SEPARATION: 'MISSING_PROPERTY_SEPARATION',
    MISSING_SIGNATURE: 'MISSING_SIGNATURE',
    MISSING_TITLE: 'MISSING_TITLE',
    MOTHER_SAME_NAME: 'MOTHER_SAME_NAME',
    NEED_ANOTHER: 'NEED_ANOTHER',
    NO_DATE: 'NO_DATE',
    NO_SIGNATURE: 'NO_SIGNATURE',
    ONE_BOX_CHECKED: 'ONE_BOX_CHECKED',
    ONE_OR_TWO_BOX_CHECKED: 'ONE_OR_TWO_BOX_CHECKED',
    PARENTS_MARITAL_STATUS: 'PARENTS_MARITAL_STATUS',
    PARENTS_SAME_LINE: 'PARENTS_SAME_LINE',
    PHOTO_MONTAGE: 'PHOTO_MONTAGE',
    PROOF_OF_REQUEST_ADDRESS_CHANGE_INVALID: 'PROOF_OF_REQUEST_ADDRESS_CHANGE_INVALID',
    PROOF_PROVISION_OWNER_INVALID: 'PROOF_PROVISION_OWNER_INVALID',
    PROOF_RADIATION_INVALID: 'PROOF_RADIATION_INVALID',
    PROPERTY_TAX_INCOMPLETE: 'PROPERTY_TAX_INCOMPLETE',
    READ_AND_APPROVED_MISSING: 'READ_AND_APPROVED_MISSING',
    SCREENSHOT: 'SCREENSHOT',
    SIGNATURE_DATE: 'SIGNATURE_DATE',
    SIGNATURE_DOES_NOT_MATCH: 'SIGNATURE_DOES_NOT_MATCH',
    TITLE_MISSING: 'TITLE_MISSING',
    TYPE_NOT_SUPPORTED: 'TYPE_NOT_SUPPORTED',
    UNKNOWN_PARENT: 'UNKNOWN_PARENT',
    UNREADABLE: 'UNREADABLE',
    UPLOAD_ERROR: 'UPLOAD_ERROR',
    VITALE_CARD_INVALID: 'VITALE_CARD_INVALID',
    VTC_CARD_RECTO_INVALID: 'VTC_CARD_RECTO_INVALID',
    VTC_CARD_VERSO_INVALID: 'VTC_CARD_VERSO_INVALID',
    WRONG_BIRTH_DATE: 'WRONG_BIRTH_DATE',
    WRONG_ID: 'WRONG_ID',
    WRONG_MARITAL_STATUS: 'WRONG_MARITAL_STATUS',
};
